import React from 'react' 
import contestrat from '../../../../Images/CM2_ Strategy Development.png' 
import highquality from '../../../../Images/CM2_ High-Quality.png' 
import searcheng from '../../../../Images/CM2_ SEO.png' 
import contentdistri from '../../../../Images/CM2_ Distribution.png' 
import measurement from '../../../../Images/CM2_ Analytics.png' 
import Tailored from '../../../../Images/CM_in_ Tailored.png' 
import Compelling  from '../../../../Images/CM_in_ Compelling.png' 
import SEO from '../../../../Images/CM_in_ SEO.png' 
import Strategic from '../../../../Images/CM_in_ Strategic.png' 
import Engagement from '../../../../Images/CM_in_ Engagement.png' 
import Performance from '../../../../Images/CM_in_ Performance.png' 

function ContentMarketingBusiness() {
    return (
        <>
            <div className="container-fluid seo-growbusiness">
                <div className="container-xl">
                    <div className="row growbusiness-text">
                        <h1>How Can We Help You Grow Your Business through Content Marketing? </h1>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box  '>
                                <img src={contestrat} alt="" width={55} />
                                <h2>Content Strategy Development</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={highquality} alt="" width={55} />
                                <h2>High-Quality Content Creation</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={searcheng} alt="" width={55} />
                                <h2>Search Engine Optimization (SEO)</h2>
                            </div>
                        </div>

                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={contentdistri} alt="" width={55} />
                                <h2>Content Distribution</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={measurement} alt="" width={55} />
                                <h2>Analytics and Measurement</h2>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid  mb-5">
                <div className="container-xl">
                    <div className="row seo-work">
                        <h1>Our Content Marketing Work Includes</h1>
                        <p>Enhance your online image through our customized content marketing service. Crafted with excellence, it forges trust and loyalty, extending your reach beyond mere advertisements and serving as the cornerstone of prosperous online marketing.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Tailored} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Tailored Strategy</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Tailoring a strategy is like creating a unique roadmap for your business. Understanding goals, audience, and brand leads to a custom plan.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Compelling} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Compelling Content</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Compelling content, like captivating storytelling, grabs your attention, keeps you reading, and forms a journey, message, and connection.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={SEO} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>SEO Optimization</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>SEO optimization, like a secret sauce, ensures your content is found where people look, much like putting a sign on a bustling street.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Strategic} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Strategic Distribution</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Strategic distribution is like sharing news - putting content where and when it matters to reach the right audience, like sending party invites.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Engagement} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Engagement and Conversion</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Engagement and conversion: are like turning friends into partners by connecting and turning interest into action—from a hello to making plans.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Performance} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Performance Analysis</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Performance analysis is like a journey checkpoint, ensuring what's working, pinpointing areas for change, and staying on the right track.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ContentMarketingBusiness